






















































































import Vue from 'vue'
import _ from 'lodash'
// @ts-ignore
import { Task } from '@/model/planning/Task'
import {
  GET_SELECTED_UI_LANGUAGE,
  PLANNING_ASSISTANT_GET_IS_EDITTING_SERIE,
  PLANNING_ASSISTANT_GET_PERIODICITY, PLANNING_ASSISTANT_GET_PERIODICITY_PLANNED_EMPLOYEE_LIST,
  PLANNING_ASSISTANT_GET_PLANNED_EMPLOYEE_LIST,
  PLANNING_ASSISTANT_GET_SHIFT_TEMPLATE_ITEM,
  PLANNING_ASSISTANT_GET_TASK_LIST
} from '@/store/getter-types'
import { PlannedEmployee } from '@/model/planning/PlannedEmployee'
import { ShiftTemplate } from '@/model/planning/ShiftTemplate'
import {
  PLANNING_ASSISTANT_SET_PERIODICITY_PLANNED_EMPLOYEE_LIST,
  PLANNING_ASSISTANT_SET_PLANNED_EMPLOYEE_LIST
} from '@/store/action-types'
import { PlanningAssistantPeriodicityPayload } from '@/types/payload'
import { PeriodicityPlannedEmployee } from '@/types'
import moment from 'moment'

interface EditableEmployee {
  id: number | undefined,
  name: string | undefined,
  number: number | undefined,
  taskId: number | undefined,
  taskName: string | undefined,
  note: string | undefined,
  isPlaceholder: boolean
}

interface ComponentData {
  editableEmployeeList: EditableEmployee[] | any
  panel: number[]
}

export default Vue.extend({
  name: 'ShiftEditorWork',

  components: {},

  props: {
    editWork: Boolean
  },

  data (): ComponentData {
    return {
      editableEmployeeList: [],
      panel: [0]
    }
  },

  computed: {
    selectedShiftTemplateItem (): ShiftTemplate | undefined {
      return this.$store.getters[PLANNING_ASSISTANT_GET_SHIFT_TEMPLATE_ITEM]
    },

    taskList (): Task[] {
      return this.$store.getters[PLANNING_ASSISTANT_GET_TASK_LIST]
    },

    showAutomaticPlanning (): boolean {
      return !!this.selectedShiftTemplateItem
    },

    showFreePlanning (): boolean {
      return !this.selectedShiftTemplateItem
    },

    plannedEmployeeList (): PlannedEmployee[] {
      return this.$store.getters[PLANNING_ASSISTANT_GET_PLANNED_EMPLOYEE_LIST]
    },

    plannedEditableEmployeeList (): EditableEmployee[] {
      const temporaryEmployees: EditableEmployee[] = []

      this.plannedEmployeeList.forEach((employee: PlannedEmployee) => {
        let isEmployeeCreated = false

        if (!isEmployeeCreated) {
          const editableEmployee: EditableEmployee = {
            id: employee.id,
            name: employee.name,
            number: employee.number,
            taskId: employee.taskId,
            taskName: employee.taskName,
            note: employee.note,
            isPlaceholder: employee.isPlaceholder
          }
          temporaryEmployees.push(editableEmployee)
        }
      })
      this.editableEmployeeList = []
      this.editableEmployeeList = _.cloneDeep(temporaryEmployees)
      return this.editableEmployeeList
    },

    periodicityPlannedEmployeeList (): PeriodicityPlannedEmployee[] {
      return this.$store.getters[PLANNING_ASSISTANT_GET_PERIODICITY_PLANNED_EMPLOYEE_LIST]
    },

    periodicityPlannedEditableEmployeeList (): PeriodicityPlannedEmployee[] {
      this.editableEmployeeList = []
      this.editableEmployeeList = _.cloneDeep(this.periodicityPlannedEmployeeList.map((item: PeriodicityPlannedEmployee) => {

        const temporaryEmployees: EditableEmployee[] = []
        let isEmployeeCreated = false

        if (!isEmployeeCreated) {
          item.employeeList.forEach((employee: PlannedEmployee) => {
            const editableEmployee: EditableEmployee = {
              id: employee.id,
              name: employee.name,
              number: employee.number,
              taskId: employee.taskId,
              taskName: employee.taskName,
              note: employee.note,
              isPlaceholder: employee.isPlaceholder
            }
            temporaryEmployees.push(editableEmployee)
          })
        }

        return { date: item.date, employeeList: temporaryEmployees }
      }))

      return this.editableEmployeeList
    },

    periodicity (): PlanningAssistantPeriodicityPayload {
      return this.$store.getters[PLANNING_ASSISTANT_GET_PERIODICITY]
    },

    isEdittingSerie (): boolean {
      return this.$store.getters[PLANNING_ASSISTANT_GET_IS_EDITTING_SERIE]
    },

    selectedLanguage (): string {
      return this.$store.getters[GET_SELECTED_UI_LANGUAGE].code
    }
  },

  watch: {
    taskList (newVal: Task[]) {
      if (newVal) {
        if (!this.periodicity.isUnique && this.isEdittingSerie) {
          this.editableEmployeeList.forEach((item: any, index: number) => {
            item.employeeList.forEach((employee: any) => {
              this.onTaskSelectPeriodicity(employee, index)
            })
          })
        } else {
          this.editableEmployeeList.forEach((item: EditableEmployee) => {
            this.onTaskSelect(item)
          })
        }
      }
    },

    editWork (newVal: boolean): void {
      if(newVal) {
        setTimeout(() => {
          const focusedField: any = document.getElementById('focused1Field1')
          const focusedField2: any = document.getElementById('1focused1Field1')
          if (focusedField) {
            focusedField.focus()
          } else if (focusedField2) {
            focusedField2.focus()
          }

          this.$emit('changeEditWork')
        }, 0)
      }
    }
  },

  methods: {
    onKeyDown (event: any): void {
      if(this.periodicityPlannedEditableEmployeeList) {
        const index1: number = this.periodicityPlannedEditableEmployeeList.length
        let index2: number = 0
        if (this.periodicityPlannedEditableEmployeeList[index1 - 1] && this.periodicityPlannedEditableEmployeeList[index1 - 1].employeeList) {
          index2 = this.periodicityPlannedEditableEmployeeList[index1 - 1].employeeList.length
        }
        if (event.code === 'Tab' && !event.shiftKey && (this.periodicityPlannedEditableEmployeeList.length) > 0 && event.target && event.target.id === `2focused${index1}Field${index2}`) {
          this.$emit('goToNextStep')
        } else if (event.code === 'ArrowUp' && !event.shiftKey) {
          this.$emit('goToNextStep')
        }
      }
    },

    onKeyDown2 (event: any): void {
      if(event.code === 'Tab' && !event.shiftKey && (this.plannedEditableEmployeeList.length) > 0 &&  event.target && event.target.id === `focused2Field${this.plannedEditableEmployeeList.length}`) {
        this.$emit('goToNextStep')
      } else if(event.code === 'ArrowUp' && !event.shiftKey) {
        this.$emit('goToNextStep')
      }
    },

    formattedDate (date: string): string {
      return moment(date, 'DD.MM.YYYY').locale(this.selectedLanguage).format('DD.MM.YYYY - dddd')
    },

    updateEmployeeNote (employee: EditableEmployee, isClearNoteEvent: boolean): void {
      let employeeIndex: number = -1

      const localPlannedEmployeeList = _.cloneDeep(this.plannedEmployeeList)

      if (employee.isPlaceholder) {
        employeeIndex = _.findIndex(localPlannedEmployeeList, { number: employee.number })
      } else {
        employeeIndex = _.findIndex(localPlannedEmployeeList, { id: employee.id })
      }

      let updatedPlannedEmployee = localPlannedEmployeeList[employeeIndex!].update(undefined, isClearNoteEvent ? '' : employee.note)

      if (employeeIndex !== -1) {
        localPlannedEmployeeList.splice(employeeIndex, 1, updatedPlannedEmployee)
        this.$store.dispatch(PLANNING_ASSISTANT_SET_PLANNED_EMPLOYEE_LIST, localPlannedEmployeeList)
      }
    },

    updateEmployeeNotePeriodicity (employee: EditableEmployee, idx: number, isClearNoteEvent: boolean): void {
      let employeeIndex: number = -1
      const localPlannedEmployeeList = _.cloneDeep(this.periodicityPlannedEmployeeList)

      if (employee.isPlaceholder) {
        employeeIndex = _.findIndex(localPlannedEmployeeList[idx].employeeList, { number: employee.number })
      } else {
        employeeIndex = _.findIndex(localPlannedEmployeeList[idx].employeeList, { number: employee.number })
      }

      let updatedPlannedEmployee = localPlannedEmployeeList[idx].employeeList[employeeIndex!].update(undefined, isClearNoteEvent ? '' : employee.note)

      if (employeeIndex !== -1) {
        localPlannedEmployeeList[idx].employeeList.splice(employeeIndex, 1, updatedPlannedEmployee)

        this.$store.dispatch(PLANNING_ASSISTANT_SET_PERIODICITY_PLANNED_EMPLOYEE_LIST, localPlannedEmployeeList)
      }
    },

    onTaskSelect (employee: EditableEmployee): void {
      let employeeIndex: number = -1

      const localPlannedEmployeeList = _.cloneDeep(this.plannedEmployeeList)

      const task: Task | undefined = this.taskList.find((item: Task) => item.id === employee.taskId)

      if (employee.isPlaceholder) {
        employeeIndex = _.findIndex(localPlannedEmployeeList, { number: employee.number })
      } else {
        employeeIndex = _.findIndex(localPlannedEmployeeList, { id: employee.id })
      }

      let updatedPlannedEmployee = localPlannedEmployeeList[employeeIndex!].update(task, undefined)

      if (employeeIndex !== -1) {
        localPlannedEmployeeList.splice(employeeIndex, 1, updatedPlannedEmployee)
        this.$store.dispatch(PLANNING_ASSISTANT_SET_PLANNED_EMPLOYEE_LIST, localPlannedEmployeeList)
      }
    },

    onClearWork (employee: EditableEmployee): void {
      let employeeIndex: number = -1

      const localPlannedEmployeeList = _.cloneDeep(this.plannedEmployeeList)

      if (employee.isPlaceholder) {
        employeeIndex = _.findIndex(localPlannedEmployeeList, { number: employee.number })
      } else {
        employeeIndex = _.findIndex(localPlannedEmployeeList, { id: employee.id })
      }

      let updatedPlannedEmployee = localPlannedEmployeeList[employeeIndex!].clearTask()

      if (employeeIndex !== -1) {
        localPlannedEmployeeList.splice(employeeIndex, 1, updatedPlannedEmployee)
        this.$store.dispatch(PLANNING_ASSISTANT_SET_PLANNED_EMPLOYEE_LIST, localPlannedEmployeeList)
      }
    },

    onTaskSelectPeriodicity (employee: EditableEmployee, idx: number): void {
      let employeeIndex: number = -1
      const localPlannedEmployeeList = _.cloneDeep(this.periodicityPlannedEmployeeList)
      const task: Task | undefined = this.taskList.find((item: Task) => item.id === employee.taskId)

      if (employee.isPlaceholder) {
        employeeIndex = _.findIndex(localPlannedEmployeeList[idx].employeeList, { number: employee.number })
      } else {
        employeeIndex = _.findIndex(localPlannedEmployeeList[idx].employeeList, { number: employee.number })
      }

      let updatedPlannedEmployee = localPlannedEmployeeList[idx].employeeList[employeeIndex!].update(task, undefined)

      if (employeeIndex !== -1) {
        localPlannedEmployeeList[idx].employeeList.splice(employeeIndex, 1, updatedPlannedEmployee)
        this.$store.dispatch(PLANNING_ASSISTANT_SET_PERIODICITY_PLANNED_EMPLOYEE_LIST, localPlannedEmployeeList)
      }
    },

    onClearWorkPeriodicity (employee: EditableEmployee, idx: number): void {
      let employeeIndex: number = -1
      const localPlannedEmployeeList = _.cloneDeep(this.periodicityPlannedEmployeeList)

      if (employee.isPlaceholder) {
        employeeIndex = _.findIndex(localPlannedEmployeeList[idx].employeeList, { number: employee.number })
      } else {
        employeeIndex = _.findIndex(localPlannedEmployeeList[idx].employeeList, { number: employee.number })
      }

      let updatedPlannedEmployee = localPlannedEmployeeList[idx].employeeList[employeeIndex!].clearTask()

      if (employeeIndex !== -1) {
        localPlannedEmployeeList[idx].employeeList.splice(employeeIndex, 1, updatedPlannedEmployee)
        this.$store.dispatch(PLANNING_ASSISTANT_SET_PERIODICITY_PLANNED_EMPLOYEE_LIST, localPlannedEmployeeList)
      }
    },

    onNoteSelect (employee: EditableEmployee): void {
      this.updateEmployeeNote(employee, false)
    },

    onNoteSelectPeriodicity (employee: EditableEmployee, idx: number): void {
      this.updateEmployeeNotePeriodicity(employee, idx, false)
    },

    onNoteClear (employee: EditableEmployee): void {
      this.updateEmployeeNote(employee, true)
    },

    onNoteClearPeriodicity (employee: EditableEmployee, idx: number): void {
      this.updateEmployeeNotePeriodicity(employee, idx, true)
    }
  }
})
